import { Datei } from '../datei/datei.model';
import { Kontakt } from '../kontakt/kontakt.model';
export class Kategorie {
  id: string;
  bezeichnung: string;
  datei: Datei;
  typ: number;
  sortierung: number;
  anzUngelNachr: number;
  anzNachr: number;
  kontakte: Kontakt[] = Array<Kontakt>();
}